/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useContext } from 'react';

import { AttachmentsFilesContext } from '../context/attachmentFiles';

export const useAttachment = () => useContext(AttachmentsFilesContext);
